export const formDate = (date: string | number) => {
  const dateParsed = new Date(date); // new Date(date * 1000);
  const hours = dateParsed.getHours().toString();
  const formattedHours = +hours > 12 ? +hours - 12 : hours;
  const minutes = dateParsed.getMinutes().toString();
  return `${dateParsed.toLocaleDateString()} ${hours.length === 1 ? '0' + hours : hours}:${
    minutes.length === 1 ? '0' + minutes : minutes
  } ${formattedHours != hours ? 'PM' : 'AM'}`;
};
